import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const Header = () => {
  const [scrolled, setScrolled]   = useState(false);
  const [menuOpen, setMenuOpen]   = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  // Close mobile menu on route change
  useEffect(() => setMenuOpen(false), [location.pathname]);

  const navLinks = [
    { to: '/',        label: 'Home'    },
    { to: '/menu',    label: 'Menu'    },
    { to: '/gallery', label: 'Gallery' },
    { to: '/contact', label: 'Contact' },
  ];

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled ? 'nav-scrolled py-3' : 'py-6'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 flex items-center justify-between">

        {/* ── Logo ─────────────────────────────────────── */}
        <Link to="/" className="flex items-center gap-3 group">
          <div className="relative w-11 h-11 border border-warm-gold flex items-center justify-center text-warm-gold font-serif font-bold text-lg transition-all duration-300 group-hover:bg-warm-gold group-hover:text-ink">
            <span>王</span>
            {/* corner accents */}
            <span className="absolute -top-1 -left-1 w-2.5 h-2.5 border-t border-l border-warm-gold"></span>
            <span className="absolute -top-1 -right-1 w-2.5 h-2.5 border-t border-r border-warm-gold"></span>
            <span className="absolute -bottom-1 -left-1 w-2.5 h-2.5 border-b border-l border-warm-gold"></span>
            <span className="absolute -bottom-1 -right-1 w-2.5 h-2.5 border-b border-r border-warm-gold"></span>
          </div>
          <div className="leading-none">
            <span className="block font-serif text-white text-lg font-bold tracking-tight">Tastywood</span>
            <span className="block text-warm-gold text-xs tracking-[0.35em] uppercase mt-0.5">Toronto · Canada</span>
          </div>
        </Link>

        {/* ── Desktop Nav ──────────────────────────────── */}
        <nav className="hidden md:flex items-center gap-8">
          {navLinks.map(({ to, label }) => (
            <Link
              key={to}
              to={to}
              className={`nav-link text-xs tracking-[0.2em] uppercase font-medium ${
                location.pathname === to
                  ? 'text-warm-gold active'
                  : 'text-white/70 hover:text-warm-gold'
              }`}
            >
              {label}
            </Link>
          ))}

          <Link
            to="/contact"
            className="ml-2 px-7 py-2.5 text-xs tracking-[0.2em] uppercase font-semibold text-white bg-imperial-red hover:bg-warm-gold hover:text-ink transition-all duration-300"
          >
            Reserve
          </Link>
        </nav>

        {/* ── Mobile Burger ────────────────────────────── */}
        <button
          className="md:hidden flex flex-col gap-1.5 p-1"
          onClick={() => setMenuOpen(o => !o)}
          aria-label="Toggle menu"
        >
          <span className={`block w-6 h-0.5 bg-warm-gold origin-center transition-transform duration-300 ${menuOpen ? 'rotate-45 translate-y-2' : ''}`}></span>
          <span className={`block w-6 h-0.5 bg-warm-gold transition-opacity duration-300 ${menuOpen ? 'opacity-0' : ''}`}></span>
          <span className={`block w-6 h-0.5 bg-warm-gold origin-center transition-transform duration-300 ${menuOpen ? '-rotate-45 -translate-y-2' : ''}`}></span>
        </button>
      </div>

      {/* ── Mobile Drawer ──────────────────────────────── */}
      <div className={`md:hidden overflow-hidden transition-all duration-500 ${menuOpen ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'}`}>
        <div className="bg-ink/95 backdrop-blur-xl border-t border-warm-gold/10 mt-3">
          <div className="max-w-7xl mx-auto px-6 py-6 space-y-1">
            {navLinks.map(({ to, label }) => (
              <Link
                key={to}
                to={to}
                className="flex items-center gap-3 py-3 border-b border-white/5 text-white/70 hover:text-warm-gold text-xs tracking-[0.25em] uppercase transition-colors"
              >
                <span className="text-warm-gold/40">—</span>
                {label}
              </Link>
            ))}
            <div className="pt-4">
              <Link
                to="/contact"
                className="block w-full text-center py-3 bg-imperial-red text-white text-xs tracking-[0.25em] uppercase font-semibold hover:bg-warm-gold hover:text-ink transition-all duration-300"
              >
                Reserve a Table
              </Link>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
